import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber } from '../../utils/generalFunctions';

import { buscarDashboard } from '../../actions/dashboard';

const DashboardAdministrador = () => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.dashboard);
    const { usuario } = useSelector(state => state.auth);

    const [dashboardData, setDashboardData] = useState({
        administradores: null, 
        asesores: null, 
        clientes_con: null, 
        clientes_sin: null, 
        asesorias_curso: null, 
        asesorias_finalizadas: null, 
        correo: null, 
        llamada: null, 
        whatsapp: null, 
        presencial: null, 
        membresia_mas: null, 
        membresia_menos: null, 
        asesor_mas: null, 
        asesor_menos: null, 
        cliente_mas: null, 
        cliente_menos: null
    });

    useEffect(() => {
        dispatch(buscarDashboard('administrador'));
    }, []);

    useEffect(() => {
        if(detalles){
            setDashboardData({
                ...dashboardData, 
                administradores: detalles.administradores, 
                asesores: detalles.asesores, 
                clientes_con: detalles.clientes_con, 
                clientes_sin: detalles.clientes_sin, 
                asesorias_curso: detalles.asesorias_curso, 
                asesorias_finalizadas: detalles.asesorias_finalizadas, 
                correo: detalles.correo, 
                llamada: detalles.llamada, 
                whatsapp: detalles.whatsapp, 
                presencial: detalles.presencial, 
                membresia_mas: detalles.membresia_mas, 
                membresia_menos: detalles.membresia_menos, 
                asesor_mas: detalles.asesor_mas, 
                asesor_menos: detalles.asesor_menos, 
                cliente_mas: detalles.cliente_mas, 
                cliente_menos: detalles.cliente_menos
            });
        }        
    }, [detalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .imagen_perfil {
                            height: 100px;
                            width: 100px;
                            border-radius: 50%;
                            border: 2px solid #111f62;
                            margin-right: 15px;
                        }

                        .titulo {
                            color: #111f62;
                        }

                        .indicador {
                            font-size: 18px;
                            margin: 0;
                        }

                        .subtitulo {
                            margin: 0;
                            font-weight: 700;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
        
            <div className="col-md-12 d-flex align-items-center mb-2">
                <img className="imagen_perfil" src={usuario.url_perfil_g != null ? usuario.url_perfil_g : process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'}/>
                <h4 className="titulo">
                    ¡Hola {[usuario.nombre, usuario.apellido_paterno, usuario.apellido_materno].join(' ')}!
                </h4>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Usuarios</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.administradores != null && dashboardData.administradores != undefined ? formatNumber(dashboardData.administradores, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">administradores</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.asesores != null && dashboardData.asesores != undefined ? formatNumber(dashboardData.asesores, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">asesores</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Clientes</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.clientes_con != null && dashboardData.clientes_con != undefined ? formatNumber(dashboardData.clientes_con, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">con empresa</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.clientes_sin != null && dashboardData.clientes_sin != undefined ? formatNumber(dashboardData.clientes_sin, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">sin empresa</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Asesorías</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.asesorias_curso != null && dashboardData.asesorias_curso != undefined ? formatNumber(dashboardData.asesorias_curso, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">en curso</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.asesorias_finalizadas != null && dashboardData.asesorias_finalizadas != undefined ? formatNumber(dashboardData.asesorias_finalizadas, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">finalizadas</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-8 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Historial de contacto</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.correo != null && dashboardData.correo != undefined ? formatNumber(dashboardData.correo, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">por correo</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.llamada != null && dashboardData.llamada != undefined ? formatNumber(dashboardData.llamada, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">por llamada</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.whatsapp != null && dashboardData.whatsapp != undefined ? formatNumber(dashboardData.whatsapp, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">por whatsapp</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.presencial != null && dashboardData.presencial != undefined ? formatNumber(dashboardData.presencial, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">presencial</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Membresía</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.membresia_mas != null && dashboardData.membresia_mas != undefined ? dashboardData.membresia_mas : 'Sin definir'}</p>
                                <p className="subtitulo">más adquirida</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.membresia_menos != null && dashboardData.membresia_menos != undefined ? dashboardData.membresia_menos : 'Sin definir'}</p>
                                <p className="subtitulo">menos adquirida</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Asesor</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.asesor_mas != null && dashboardData.asesor_mas != undefined ? dashboardData.asesor_mas : 'Sin definir'}</p>
                                <p className="subtitulo">con más asesorías</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.asesor_menos != null && dashboardData.asesor_menos != undefined ? dashboardData.asesor_menos : 'Sin definir'}</p>
                                <p className="subtitulo">con menos asesorías</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Cliente</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_mas != null && dashboardData.cliente_mas != undefined ? dashboardData.cliente_mas : 'Sin definir'}</p>
                                <p className="subtitulo">con más asesorías</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_menos != null && dashboardData.cliente_menos != undefined ? dashboardData.cliente_menos : 'Sin definir'}</p>
                                <p className="subtitulo">con menos asesorías</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardAdministrador;